module.exports = __webpack_public_path__ + "static/about-c93be3c3d2d76cffbb53731a36bee1e2.png";